module.exports = __webpack_public_path__ + "static/media/FreeCAD-logo.svg.7c0a1731.png";